export default "7a2f1904b0b14f6b.svg"